import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalStateService } from '../services/modal-state.service';
import { Router } from "@angular/router";
import { SESSION_STORAGE_KEYS } from '../../constants';
import { TilesService } from '../services/user/tiles.service';
import { CloudWatchRumService } from '../services/cloudwatch-rum.service';
import { SessionInvalidationService } from '../services/session-invalidation.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-session-timeout-modal',
  standalone: true,
  imports: [],
  templateUrl: './session-timeout-modal.component.html',
  styleUrl: './session-timeout-modal.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SessionTimeoutModalComponent implements OnInit {

  constructor (
    private modalStateService: ModalStateService, 
    private router: Router,
    private tilesService: TilesService,
    private cloudWatchRumService: CloudWatchRumService,
    private sessionInvalidationService: SessionInvalidationService
  ) {}

  // Default modal
  defaultModalVisible = false;

  ngOnInit(): void {
      // Clear embed URL cache when session times out
      this.tilesService.clearEmbedUrlCache();
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.CHAT_HISTORY);
      this.defaultModalVisible = true;
  }

  onModalLogoffButtonClicked(): void {
      // Record auto-logout event before navigating
      this.cloudWatchRumService.recordLogoutEvent(true, 'timeout_modal');

      const invalidateSession$ = this.sessionInvalidationService.invalidateSession().pipe(take(1));

      sessionStorage.removeItem('refresh_token');
      this.modalStateService.closeModal();
      this.router.navigate(['/logoff']);

      invalidateSession$.subscribe((isInvalidated) => {
        this.cloudWatchRumService.addCustomEvent('session_invalidate_result', {
          success: !!isInvalidated,
          source: 'timeout_modal'
        });
      });
  }

  onModalExtentButtonClicked(): void {
    this.modalStateService.closeModal();
  }
}
